var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trial-premium" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "trial-info" }, [
      _c("span", { staticClass: "text-gray font-bold" }, [
        _vm._v("トライアル終了まで残り")
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "font-bold",
          class: {
            "text-green": _vm.premiumTrialDate > 7,
            "text-red": _vm.premiumTrialDate <= 7
          }
        },
        [
          _c("span", { staticClass: "text-size-24" }, [
            _vm._v(_vm._s(_vm.premiumTrialDate))
          ]),
          _vm._v("日\n    ")
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-custom",
          on: {
            click: function($event) {
              _vm.handleClickViewPremiumTrial()
            }
          }
        },
        [
          _c("i", { staticClass: "fa fa-hand-o-right" }),
          _vm._v("\n      継続はコチラ\n    ")
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bubble-dots" }, [
      _c("span", { staticClass: "dot dot-1" }),
      _vm._v(" "),
      _c("span", { staticClass: "dot dot-2" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33f0abaf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33f0abaf","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PremiumTrial.vue
// module id = null
// module chunks = 